import React from 'react';
import { Typography } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import makeStyles from '@material-ui/styles/makeStyles/makeStyles';
import { colors } from '@skyslope/mache';
import type { LaunchDarklyFlags } from '../../common/launchDarkly';
import type { IEnvelopeMetadata } from '../../store/envelopeManagement/types';
import ActionsMenu from './ActionsMenu';

const useStyles = makeStyles(() => ({
  statusActionButton: {
    padding: 6,
    margin: -7,
    borderRadius: '28px !important',
    '&:hover': {
      backgroundColor: `${colors.blue[100]} !important`,
      color: colors.blue[800],
    },
  },
}));

interface IProps {
  envelope: IEnvelopeMetadata;
  sender?: { firstName: string; lastName: string; email: string };
  canSignInPerson?: boolean;
  isDelegate?: boolean;
  flags: LaunchDarklyFlags;
}

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const StatusActionCell = (props: IProps) => {
  const { envelope, sender, canSignInPerson, isDelegate, flags } = props;
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const buttonRef = React.useRef(null);
  // eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
  const openMenu = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    setOpen(true);
    buttonRef.current = event.currentTarget;
  };
  // eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
  const closeMenu = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen(false);
    buttonRef.current = null;
  };
  return (
    <>
      <IconButton
        color="primary"
        onClick={openMenu}
        className={classes.statusActionButton}
        aria-label="More envelope actions"
      >
        <Typography style={{ color: colors.blue[800], fontWeight: 'bold' }}>More</Typography>
        <MoreVertIcon />
      </IconButton>
      <ActionsMenu
        open={Boolean(open)}
        envelope={envelope}
        anchorEl={buttonRef.current}
        onClose={closeMenu}
        sender={sender}
        canSignInPerson={canSignInPerson}
        isDelegate={isDelegate}
        flags={flags}
      />
    </>
  );
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default StatusActionCell;
